import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import type {
  WasteSummary,
  WasteTrendPoint,
  WasteByPart,
  WasteByMaterial,
} from "@shared/types";

export function useWasteSummary(from: string, to: string, product?: string) {
  return useQuery({
    queryKey: ["waste", "summary", from, to, product],
    queryFn: () =>
      apiFetch<WasteSummary>("/api/waste/summary", {
        from,
        to,
        product: product || undefined,
      }),
  });
}

export function useWasteTrend(
  from: string,
  to: string,
  product?: string,
  bucket?: string
) {
  return useQuery({
    queryKey: ["waste", "trend", from, to, product, bucket],
    queryFn: () =>
      apiFetch<WasteTrendPoint[]>("/api/waste/trend", {
        from,
        to,
        product: product || undefined,
        bucket: bucket || undefined,
      }),
  });
}

export function useWasteByPart(from: string, to: string) {
  return useQuery({
    queryKey: ["waste", "by-part", from, to],
    queryFn: () =>
      apiFetch<WasteByPart[]>("/api/waste/by-part", { from, to }),
  });
}

export function useWasteByMaterial(from: string, to: string, product?: string) {
  return useQuery({
    queryKey: ["waste", "by-material", from, to, product],
    queryFn: () =>
      apiFetch<WasteByMaterial[]>("/api/waste/by-material", {
        from,
        to,
        product: product || undefined,
      }),
  });
}
